import {
  serviceFrequencyTodayColumns,
  serviceFrequencyTodayDefaultColumns,
  serviceFrequencyTodaySorts,
  serviceFrequencyTodaySpecificFilters,
  serviceFrequencyTodaySummary,
} from '@cabgo/shared';
import type { ReportViewDefinition } from '../reportViewTypes';

export const serviceFrequencyTodayView: ReportViewDefinition = {
  key: 'service_frequency_today',
  titleKey: 'sftTitle',
  descriptionKey: 'sftDescription',
  dateBasisKey: 'sftDateBasis',
  columns: serviceFrequencyTodayColumns,
  defaultColumns: serviceFrequencyTodayDefaultColumns,
  dateMode: 'today',
  supportsSearch: false,
  defaultSort: 'providerName',
  sorts: serviceFrequencyTodaySorts,
  filters: serviceFrequencyTodaySpecificFilters.map((filter) => ({
    ...filter,
    labelKey: `sftFilter_${filter.id}`,
    ...(filter.id === 'serviceMode'
      ? {
          options: filter.values.map((value) => ({ value, labelKey: `sftMode_${value}` })),
        }
      : {}),
  })),
  valueLabels: {
    date_basis: { SERVICE_DATE: 'sftValueServiceDate' },
    scope_provenance: { CURRENT_SERVICE_GROUP: 'sftValueCurrentScope' },
    active_agent_basis: { ACCEPTED_ASSIGNMENT_IN_SERVICE_COHORT: 'sftValueActiveBasis' },
  },
  summary: serviceFrequencyTodaySummary,
  primarySummary: [
    'tripCount',
    'acceptedTripCount',
    'completedTripCount',
    'cancelledTripCount',
    'missedTripCount',
    'outstandingTotalSum',
  ],
  summaryGroups: [
    {
      labelKey: 'summaryGroupOverview',
      fields: [
        'tripCount',
        'acceptedTripCount',
        'completedTripCount',
        'cancelledTripCount',
        'missedTripCount',
      ],
    },
    {
      labelKey: 'summaryGroupFinance',
      fields: [
        'fareTotalSum',
        'billedTotalSum',
        'receivedTotalSum',
        'outstandingTotalSum',
        'freeTripCount',
        'financeReviewCount',
      ],
    },
    { labelKey: 'summaryGroupDispatch', fields: ['activeAgentCount'] },
    { labelKey: 'summaryGroupEvidence', fields: ['missingFareCount'] },
  ],
  coverage: [
    { field: 'scheduledDateTripCount', labelKey: 'sftColumn_scheduled_date_trip_count' },
    { field: 'createdDateFallbackTripCount', labelKey: 'sftColumn_created_date_fallback_trip_count' },
    { field: 'missingAcceptedEvidenceCount', labelKey: 'sftColumn_missing_accepted_evidence_count' },
    { field: 'missingCompletedEvidenceCount', labelKey: 'sftColumn_missing_completed_evidence_count' },
    { field: 'missingAgentEvidenceCount', labelKey: 'sftColumn_missing_agent_evidence_count' },
    { field: 'missingFareCount', labelKey: 'sftColumn_missing_fare_count' },
  ],
};
